import React from 'react';
import { motion } from 'framer-motion';

function LegalNotice() {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="min-h-screen bg-gray-50 py-12"
    >
      <div className="container mx-auto px-4 max-w-3xl">
        <div className="bg-white rounded-xl shadow-lg p-8">
          <h1 className="text-3xl font-bold mb-6">Yasal Uyarı</h1>
          
          <div className="prose prose-blue max-w-none">
            <p className="text-gray-600 mb-6">
              Son güncelleme tarihi: {new Date().toLocaleDateString('tr-TR')}
            </p>

            <h2 className="text-xl font-semibold mt-8 mb-4">1. Genel Bilgiler</h2>
            <p>
              Bu web sitesi Excel Vadisi tarafından işletilmektedir. Bu yasal uyarı, sitemizin kullanımına 
              ilişkin önemli bilgiler içermektedir.
            </p>

            <h2 className="text-xl font-semibold mt-8 mb-4">2. Telif Hakları</h2>
            <p>
              Sitede yer alan tüm içerikler (yazılar, görseller, videolar, kodlar vb.) telif hakkı ile 
              korunmaktadır. İçeriklerin izinsiz kullanımı, kopyalanması ve dağıtılması yasaktır.
            </p>

            <h2 className="text-xl font-semibold mt-8 mb-4">3. Sorumluluk Reddi</h2>
            <p>
              Sitemizde yer alan bilgiler genel bilgilendirme amaçlıdır. Bu bilgilerin kullanımından 
              doğabilecek herhangi bir zarardan Excel Vadisi sorumlu tutulamaz.
            </p>

            <h2 className="text-xl font-semibold mt-8 mb-4">4. Üçüncü Taraf Bağlantıları</h2>
            <p>
              Sitemizde yer alan üçüncü taraf bağlantılarının içeriğinden Excel Vadisi sorumlu değildir. 
              Bu bağlantılara erişim kendi sorumluluğunuzdadır.
            </p>

            <h2 className="text-xl font-semibold mt-8 mb-4">5. Ticari Markalar</h2>
            <p>
              Microsoft Excel ve VBA, Microsoft Corporation'ın tescilli ticari markalarıdır. 
              Sitemizde kullanılan diğer tüm ticari markalar ilgili sahiplerinin mülkiyetindedir.
            </p>

            <h2 className="text-xl font-semibold mt-8 mb-4">6. Değişiklikler</h2>
            <p>
              Excel Vadisi, bu yasal uyarıda herhangi bir zamanda değişiklik yapma hakkını saklı tutar. 
              Değişiklikler sitede yayınlandığı andan itibaren geçerli olacaktır.
            </p>

            <h2 className="text-xl font-semibold mt-8 mb-4">7. İletişim</h2>
            <p>
              Bu yasal uyarı ile ilgili sorularınız için{' '}
              <a 
                href="https://www.instagram.com/excelvbamakro/" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-blue-600 hover:text-blue-800 inline-flex items-center"
              >
                Instagram hesabımız
                <svg className="w-4 h-4 ml-1" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M11 3a1 1 0 100 2h2.586l-6.293 6.293a1 1 0 101.414 1.414L15 6.414V9a1 1 0 102 0V4a1 1 0 00-1-1h-5z" />
                  <path d="M5 5a2 2 0 00-2 2v8a2 2 0 002 2h8a2 2 0 002-2v-3a1 1 0 10-2 0v3H5V7h3a1 1 0 000-2H5z" />
                </svg>
              </a>{' '}
              üzerinden bizimle iletişime geçebilirsiniz.
            </p>
          </div>
        </div>
      </div>
    </motion.div>
  );
}

export default LegalNotice; 